import { laravelGet, laravelPost, laravelPut, laravelDelete, laravelRequest } from '../utils/laravelClient';
import { createQueryString } from '../utils/apiUtils';

export async function getAllRoles(params = {}) {
  const qs = createQueryString(params);
  const path = qs ? `/roles?${qs}` : '/roles';
  return laravelRequest('GET', path, { auth: 'admin' });
}

export async function createRole(roleData) {
  return laravelPost('/roles', roleData, { auth: 'admin' });
}

export async function updateRole(roleId, roleData) {
  return laravelPut(`/roles/${roleId}`, roleData, { auth: 'admin' });
}

export async function deleteRole(roleId) {
  return laravelDelete(`/roles/${roleId}`, { auth: 'admin' });
}
